import { Api as API } from '../../config/apiCallDispatcher';
import {
    ConversationMessages,
    ConversationStatus,
    ConversationStatuses,
    CreateConversationRequest,
    GetAllConversationStatusesRequest,
    GetConversationMessagesRequest,
    GetConversationStatusRequest,
    MarkConversationMessagesAsReadRequest,
    SendMessageRequest,
} from './types';

export const getAllConversationStatuses = async () => {
    const resopnse = await API.get('messaging-v2', `conversations`);
    return resopnse.data as ConversationStatuses;
    //return dummyConversationStatuses;
};

export const getAllConversationStatusesAfterTimestamp = async (request: GetAllConversationStatusesRequest) => {
    const response = await API.get('messaging-v2', `conversations?afterTimestamp=${request.timestamp}`);
    return response.data as ConversationStatuses;
};

export const getConversationStatus = async (request: GetConversationStatusRequest) => {
    const response = await API.get('messaging-v2', `conversations/${request.conversationId}/status`);
    return response.data as ConversationStatus;
};

export const createNewConversation = async (request: CreateConversationRequest) => {
    const response = await API.post('messaging-v2', 'conversations', request);
    return response.data as ConversationStatus;
};

export const getConversationMessages = async (request: GetConversationMessagesRequest) => {
    const response = await API.get(
        'messaging-v2',
        `conversations/${request.conversationId}/messages?afterSeqId=${request.seqId}`
    );
    return response.data as ConversationMessages;
};

export const sendMessage = async (request: SendMessageRequest) => {
    const response = await API.post(
        'messaging-v2',
        `conversations/${request.conversationId}/messages`,
        request.messageData
    );
    return response.data as ConversationStatus;
};

export const markConversationMessagesAsRead = async (request: MarkConversationMessagesAsReadRequest) => {
    const response = await API.put('messaging-v2', `conversations/${request.conversationId}/read`, {
        latestReadSeqId: request.latestReadSeqId,
    });
    return response.data as ConversationStatus;
};
